<template>
  <!-- 
      1. Copy this file then paste on the page
      2. Change title
      3. Change End points (getData, saveAddDialog, saveEditDialog, saveDeleteDialog)
      4. Add table header
      5. Add td column on datatable
      6. Add components inside the dialog components
      7. Add function for the dialog components action

      NOTE: You can remove dialog components(View,Edit,Add,Delete) if it not needed
  -->
  <v-container grid-list-xl fluid>
    <v-layout>
      <v-flex>
        <v-card>
          <v-card-title>
            <search-field ref="searchRef" @search="search"></search-field>
            <v-spacer></v-spacer>
            <!-- Refresh Button -->
            <refresh-button @refresh="refreshTable()"></refresh-button>
            <multi-assign-button
              v-if="$moduleAccess('assign_device')"
              title="Assign Device"
              @assign="openMultiAssignDialog"
            ></multi-assign-button>
            <v-fab-transition>
              <multi-delete-button
                v-if="selected.length >= 1"
                @del="openMultiDeleteDialog"
              ></multi-delete-button>
            </v-fab-transition>
            <!-- <add-button @add="openAddDialog"></add-button> -->

            <!-- Dialog for Add, View Edit  -->
            <action-dialog
              :type="dialogType"
              :title="title"
              :dialog="dialogStatus"
              @saveDialog="saveDialog"
              @closeDialog="closeDialog"
              :loading="dialogLoading"
            >
              <v-container grid-list-xs>
                <v-layout justify-center>
                  <!-- <v-flex md6> -->
                  <!-- Insert View Dialog Content BELOW-->
                  <details-container
                    ref="detailsRef"
                    :data="viewData"
                    :companies="companies"
                    :subcompanies="subcompanies"
                    :showSubCompany="dialogType === 'view'"
                    :readonly="dialogType === 'view'"
                    :hideDeviceSerial="dialogType === 'edit'"
                    :hideModel="dialogType === 'edit'"
                  />
                  <!-- </v-flex> -->
                </v-layout>
              </v-container>
            </action-dialog>

            <!-- Dialog for Multiple Assigning of Project -->
            <customize-dialog
              :type="dialogType"
              :disableSave="selected.length < 1"
              :title="title"
              action="assign"
              color="amber darken-2"
              :dialog="multiAssignDialog"
              @saveDialog="multiSaveDialog"
              @closeDialog="multiCloseDialog"
              :loading="dialogLoading"
              showSave
            >
              <v-container grid-list-xs>
                <v-layout justify-center>
                  <v-flex md7>
                    <!-- Insert View Dialog Content BELOW-->
                    <jti-expansion-panel panelName="Select Device">
                      <v-container class="scrolling-wrapper">
                        <v-text-field
                          v-model="searchData"
                          append-icon="search"
                          label="Search"
                          single-line
                          hide-details
                        ></v-text-field>
                        <v-data-table
                          v-model="selected"
                          item-key="id"
                          select-all
                          :headers="assignHeaders"
                          :search="searchData"
                          :items="assignItems"
                          hide-actions
                          disable-initial-sort
                        >
                          <template slot="headers" slot-scope="props">
                            <tr>
                              <th>
                                <v-checkbox
                                  :input-value="props.all"
                                  :indeterminate="props.indeterminate"
                                  color="primary"
                                  hide-details
                                  @click.stop="toggleAllDevices"
                                ></v-checkbox>
                              </th>
                              <th
                                v-for="header in props.headers"
                                :key="header.text"
                                :class="[
                                  'column sortable',
                                  header.value === queryParams.order
                                    ? 'active'
                                    : '',
                                  'text-xs-' + header.align
                                ]"
                              >
                                {{ header.text }}
                              </th>
                            </tr>
                          </template>
                          <template slot="items" slot-scope="props">
                            <td class="text-xs-center">
                              <v-checkbox
                                color="primary"
                                v-model="props.selected"
                                hide-details
                              ></v-checkbox>
                            </td>
                            <!-- <td class="text-xs-left text-uppercase">{{ props.item.name }}</td> -->
                            <td class="text-xs-left text-uppercase">
                              {{ props.item.device_serial }}
                            </td>
                          </template>
                        </v-data-table>
                      </v-container>
                    </jti-expansion-panel>
                  </v-flex>
                  <v-flex md5>
                    <v-form v-model="valid" ref="form" lazy-validation>
                      <jti-expansion-panel panelName="Company Selection">
                        <v-container class="py-0">
                          <v-select
                            v-model="companyModel"
                            :items="companies"
                            label="Company"
                            required
                            :rules="[rules.required]"
                          ></v-select>
                          <v-select
                            v-model="sub_company_id"
                            :items="subcompanies"
                            label="Sub-Company"
                            required
                            :rules="[rules.required]"
                            :disabled="!company_id"
                          ></v-select>
                        </v-container>
                      </jti-expansion-panel>
                      <jti-expansion-panel panelName="Device Settings">
                        <v-container class="py-0">
                          <v-switch
                            v-model="spareStatus"
                            color="primary"
                            label="Spare Device"
                          ></v-switch>
                          <v-switch
                            v-model="subCompanyStatus"
                            color="primary"
                            label="Sub-Company Selection"
                          ></v-switch>
                        </v-container>
                      </jti-expansion-panel>
                    </v-form>
                  </v-flex>
                </v-layout>
              </v-container>
            </customize-dialog>
            <confirm-dialog
              :confirmDialog="openConfirmDialog"
              @saveConfirmDialog="
                dialogType === 'edit'
                  ? saveEditDialog()
                  : dialogType === 'add'
                  ? saveAddDialog()
                  : dialogType === 'multiple'
                  ? saveMultiAssignDialog()
                  : ''
              "
              @closeConfirmDialog="closeConfirmDialog"
              :loading="confirmLoading"
            ></confirm-dialog>

            <message-dialog
              :dialog="messageDialog"
              :title="messageTitle"
              :message="messageText"
              @save="dialogType === 'remove' ? saveRemoveDialog() : ''"
              @close="closeMessageDialog"
              :loading="messageLoading"
            ></message-dialog>
          </v-card-title>
          <v-divider></v-divider>

          <v-container fluid class="pa-2">
            <v-layout row>
              <v-flex sm4 md4>
                <v-btn flat @click="openFilterExpansion">
                  <v-icon class="mr-3">{{
                    openFilter ? "keyboard_arrow_up" : "keyboard_arrow_down"
                  }}</v-icon>
                  <span>Filter {{ title }}</span>
                </v-btn>
              </v-flex>
              <v-flex sm8 md8>
                <v-container class="py-2 pr-0" fluid>
                  <v-layout row align-center>
                    <v-flex xs12 sm8 md9 class="py-0">
                      <v-layout row align-center>
                        <v-flex xs6 sm10 md11 class="px-0">
                          <p
                            class="text-xs-right grey--text caption"
                            style="font-size: 14px; margin-top: 14px;"
                          >
                            Row per Page:
                          </p>
                        </v-flex>
                        <v-flex xs6 sm2 md1 class="text-xs-center">
                          <v-layout row align-center>
                            <v-flex xs7 sm12>
                              <v-select
                                style="font-size: 14px;"
                                :items="page"
                                class="grey--text"
                                id="selected"
                                v-model="pageLimit"
                                @input="limitClick"
                                dense
                                height="20px"
                                :disabled="
                                  this.items.length < 10 ? true : false
                                "
                              ></v-select>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm4 md3 class="py-0">
                      <v-layout row align-center>
                        <v-flex xs6 sm6 class="px-0 pl-3">
                          <p
                            class="text-xs-center grey--text caption"
                            style="font-size: 14px; margin-top: 14px;"
                          >
                            {{ itemFrom + " -" + itemTo + " of " }}
                            {{ totalItems }}
                          </p>
                        </v-flex>
                        <v-flex xs6 sm6>
                          <v-layout row style="padding-right: 100px;">
                            <v-flex sm6 class="mr-3 pl-0">
                              <v-btn
                                fab
                                light
                                small
                                flat
                                @click="backClick"
                                :disabled="disabledBack"
                              >
                                <v-icon dark>chevron_left</v-icon>
                              </v-btn>
                            </v-flex>
                            <v-flex sm6>
                              <v-btn
                                fab
                                light
                                small
                                flat
                                @click="nextClick"
                                :disabled="disabledNext"
                              >
                                <v-icon dark>chevron_right</v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
            </v-layout>
          </v-container>

          <v-divider></v-divider>

          <filter-panel :openFilter="openFilter">
            <v-flex md4>
              <v-select
                v-model="filterCompany"
                :items="filterCompanies"
                label="Company"
                solo
                clearable
              ></v-select>
            </v-flex>
          </filter-panel>

          <v-data-table
            v-model="selected"
            item-key="id"
            :headers="headers"
            :items="items"
            select-all
            hide-actions
            disable-initial-sort
          >
            <template slot="headers" slot-scope="props">
              <tr>
                <!-- <th>
                  <v-checkbox
                    class="ml-5"
                    :input-value="props.all"
                    :indeterminate="props.indeterminate"
                    color="primary"
                    hide-details
                    @click.stop="toggleAll"
                  ></v-checkbox>
                </th>-->
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable',
                    header.value === queryParams.order ? 'active' : '',
                    'text-xs-' + header.align
                  ]"
                >
                  {{ header.text }}
                </th>
              </tr>
            </template>
            <template slot="items" slot-scope="props">
              <!-- <td class="text-xs-center">
                <v-checkbox class="ml-5" color="primary" v-model="props.selected" hide-details></v-checkbox>
              </td>-->
              <td class="text-xs-center">
                {{ props.index + queryParams.offset + 1 }}
              </td>
              <!-- <td class="text-xs-left text-uppercase">{{ props.item.name }}</td> -->
              <td class="text-xs-left">{{ props.item.device_serial }}</td>
              <!-- <td class="text-xs-left text-uppercase">{{ props.item.model }}</td> -->
              <td class="text-xs-left text-uppercase">
                {{ props.item.company ? props.item.company.name : "--" }}
              </td>
              <td class="text-xs-left text-uppercase">
                {{
                  props.item.sub_company ? props.item.sub_company.name : "--"
                }}
              </td>
              <td class="text-xs-center text-uppercase">
                {{ props.item.status ? "ACTIVATED" : "INACTIVE" }}
              </td>
              <td class="text-xs-center text-uppercase">
                {{ props.item.spare_status ? "spare" : "assign" }}
              </td>

              <!-- Add Cell Data BELOW -->
              <td class="text-no-wrap text-xs-center">
                <view-button @view="openViewDialog(props.item)"></view-button>
                <!-- <edit-button @edit="openEditDialog(props.item)"></edit-button> -->
                <!-- <remove-button @remove="openRemoveDialog(props.item)"></remove-button> -->
                <delete-button
                  v-if="$moduleAccess('delete_device')"
                  @delete="openRemoveDialog(props.item)"
                ></delete-button>
              </td>
            </template>
          </v-data-table>
          <v-divider></v-divider>
          <v-container class="py-0" fluid>
            <v-layout wrap align-center class="pa-5"></v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Services from "@/services/Services";
import DetailsContainer from "@/components/details_container/DeviceDetailsContainer";

export default {
  components: {
    DetailsContainer
  },
  data() {
    return {
      openFilter: false,
      title: "Device",
      headers: [
        { text: "#", align: "center", sortable: false },
        // Add your Header BELOW
        // {
        //   text: "Name",
        //   align: "left",
        //   value: "name",
        //   sortable: true
        // },
        {
          text: "Device Serial",
          align: "left",
          value: "device_serial",
          sortable: false
        },
        {
          text: "Company",
          align: "left",
          value: "company_id",
          sortable: false
        },
        {
          text: "Sub-Company",
          align: "left",
          value: "company_id",
          sortable: false
        },
        {
          text: "Status",
          align: "center",
          value: "status",
          sortable: false
        },
        {
          text: "Type",
          align: "center",
          value: "spare_status",
          sortable: false
        },
        {
          text: "Action",
          align: "center",
          sortable: false
        }
      ],
      assignHeaders: [
        {
          text: "Device Serial",
          align: "left",
          value: "device_serial",
          sortable: true
        }
      ],
      items: [],
      assignItems: [],
      searchData: "",
      queryParams: {
        search: "",
        limit: 10,
        offset: 0,
        company_id: ""
      },
      dialogType: "",
      dialogStatus: false,
      openConfirmDialog: false,
      multiAssignDialog: false,
      viewData: {},

      deleteDialog: false,
      deleteTitle: "",
      deleteType: "",

      confirmLoading: false,
      dialogLoading: false,

      totalItems: 0,
      itemFrom: 0,
      itemTo: 0,
      disabledNext: false,
      disabledBack: true,
      page: [
        { text: 10, value: 10 },
        { text: 20, value: 20 },
        { text: 30, value: 30 },
        { text: 40, value: 40 },
        { text: 50, value: 50 }
      ],
      selected: [],
      companies: [],
      subcompanies: [],
      filterCompany: null,
      filterCompanies: [],
      messageDialog: false,
      messageTitle: "",
      messageText: "",
      messageLoading: false,
      spareStatus: false,
      subCompanyStatus: false,
      valid: true,
      rules: {
        required: value => !!value || "This field is required.",
        counter: value => value.length <= 20 || "Max 20 characters"
      },
      company_id: null,
      sub_company_id: null
    };
  },
  created: function() {
    this.getData();
  },
  computed: {
    pageLimit: {
      get() {
        return null;
      },
      set(val) {
        this.queryParams.limit = val;
        this.queryParams.offset = 0;
      }
    },
    companyModel: {
      get() {
        return this.company_id;
      },
      set(val) {
        this.company_id = val;
        this.sub_company_id = null;

        this.setSubCompanies();
      }
    }
  },
  watch: {
    filterCompany: async function() {
      if (
        this.filterCompany !== null &&
        this.filterCompany !== undefined &&
        this.filterCompany !== ""
      ) {
        this.queryParams.offset = 0;
        this.queryParams.company_id = this.filterCompany;
        this.getData();
      } else {
        this.queryParams.offset = 0;
        this.queryParams.company_id = null;
        this.getData();
      }
    }
  },
  methods: {
    search(data) {
      this.queryParams.search = data;
      this.queryParams.offset = 0;
      this.queryParams.limit = 10;
      this.getData();
    },
    async getData() {
      // Start Loading
      this.$clearInfoBar();
      this.items = [];
      this.$store.dispatch("startLoading");
      try {
        // Query Data
        let response = (await Services.getDevices(this.queryParams)).data;

        // Assign the reponse data to items to be display on table
        this.items = response.data;

        // Assign Total number of data
        this.totalItems = response.count;

        // Assign Number started the data
        this.itemFrom = this.totalItems > 0 ? this.queryParams.offset + 1 : 0;

        // Assign Number end the data
        this.itemTo = this.queryParams.offset + this.queryParams.limit;

        if (this.totalItems <= this.itemTo) {
          this.itemTo = this.totalItems;
        }

        // Conditions for NextPage Button
        if (this.itemTo === this.totalItems) {
          this.disabledNext = true;
        } else {
          this.disabledNext = false;
        }
        // Conditions for BackPage Button
        if (this.itemFrom > 1) {
          this.disabledBack = false;
        } else {
          this.disabledBack = true;
        }
      } catch (error) {
        if (!error.response) {
          if (!this.$isEmpty(this.$store.state.employee)) {
            this.$infoBar({
              type: "error",
              text: "No network or server connection"
            });
          } else {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        } else {
          if (error.response.status === 403) {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        }
      }
      this.$store.dispatch("endLoading");
    },
    async setData(id) {
      var data = {};

      try {
        const response = await Services.getDevice(id);
        data = await response.data;
        data.name = data.name ? data.name.toUpperCase() : "";
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection"
          });
        }
      }
      return data;
    },
    async setCompanies() {
      this.subcompanies = [];
      const items = (await Services.getCompanies({})).data;
      for (var i = 0, el = items.data; i < el.length; i++) {
        let data = {
          text: el[i].name.toUpperCase(),
          value: el[i].id
        };
        this.companies.push(data);
      }
    },
    async setSubCompanies() {
      this.subcompanies = [];
      const items = (
        await Services.getSubCompanies({
          company_id: this.company_id
        })
      ).data;
      for (var i = 0, el = items.data; i < el.length; i++) {
        let data = {
          text: el[i].name.toUpperCase(),
          value: el[i].id
        };
        this.subcompanies.push(data);
      }
    },
    async setFilterCompanies() {
      this.filterCompanies = [];
      const items = (
        await Services.getSubCompanies({
          project_id: this.$store.state.project.id
        })
      ).data;
      await this.filterCompanies.push({
        text: "UNASSIGNED",
        value: "isNull"
      });
      for (var i = 0, el = items.data; i < el.length; i++) {
        let data = {
          text: el[i].company.name.toUpperCase(),
          value: el[i].company_id
        };
        this.filterCompanies.push(data);
      }
    },
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.items.slice();
    },
    toggleAllDevices() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.assignItems.slice();
    },
    nextClick() {
      this.queryParams.offset += this.queryParams.limit;
      this.getData();
    },
    backClick() {
      this.queryParams.offset -= this.queryParams.limit;
      this.getData();
    },
    async limitClick() {
      this.queryParams.offset = 0;
      this.getData();
    },
    itemNumber(data) {
      return data + this.queryParams.offset + 1;
    },
    async openAddDialog() {
      this.dialogLoading = true;

      this.dialogType = "add";
      this.dialogStatus = true;

      this.setCompanies();

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async openViewDialog(data) {
      this.dialogLoading = true;

      this.dialogType = "view";
      this.dialogStatus = true;

      // await this.setCompanies();

      this.viewData = await this.setData(data.id);

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async openEditDialog(data) {
      this.dialogLoading = true;

      this.dialogType = "edit";
      this.dialogStatus = true;

      // await this.setCompanies();

      this.viewData = await this.setData(data.id);

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async openRemoveDialog(data) {
      this.messageDialog = true;
      this.messageTitle = "Remove " + this.title;
      this.messageText = `Are you sure you want to Remove this ${this.title}?`;
      this.dialogType = "remove";

      this.viewData = data;
    },
    async openDeleteDialog(data) {
      this.deleteDialog = true;
      this.deleteType = "single";
      this.deleteTitle = "Are you sure you want to Delete this " + this.title;
      this.viewData.id = data.id;
    },
    async openMultiAssignDialog() {
      this.selected = [];
      this.multiAssignDialog = true;
      this.dialogType = "multiple";
      let response = (await Services.getUnassignedDevices({})).data;
      this.assignItems = response.data;
      await this.setCompanies();
    },
    openMultiDeleteDialog() {
      this.deleteDialog = true;
      this.deleteType = "multiple";
      this.deleteTitle =
        "Are you sure you want to Delete this " + this.title + "s";
    },
    saveDialog() {
      // Condition Form Required Form Validation
      if (this.$refs.detailsRef.validateForm()) {
        this.openConfirmDialog = true;
      }
    },
    multiSaveDialog() {
      this.openConfirmDialog = true;
    },
    saveUpDialog() {
      // Condition Form Required Form Validation
      this.openConfirmDialog = true;
    },
    async saveAddDialog() {
      this.confirmLoading = true;
      const data = this.$refs.detailsRef.computedData,
        body = {
          name: data.name,
          device_serial: data.device_serial,
          model: data.model,
          remarks: data.remarks,
          company_id: this.$store.state.project.id
        };
      try {
        const response = await Services.addDevice(body);

        if (response.status === 201 || response.status === 204) {
          this.closeDialog();
          await this.getData();
          this.$infoBar({
            type: "success",
            text: "Device has been added!"
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!"
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection"
          });
        }
      }
      this.confirmLoading = await false;
    },
    async saveEditDialog() {
      this.confirmLoading = true;

      const data = this.$refs.detailsRef.computedData,
        body = {
          name: data.name,
          remarks: data.remarks
        };
      try {
        const response = await Services.editDevice(data.id, body);

        if (response.status === 201 || response.status === 204) {
          this.closeDialog();
          await this.getData();
          this.$infoBar({
            type: "success",
            text: "Device has been updated!"
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!"
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection"
          });
        }
      }
      this.confirmLoading = await false;
    },
    async saveMultiAssignDialog() {
      this.confirmLoading = true;

      const devices = this.selected.map(device => {
        return {
          id: device.id
        };
      });
      const body = {
        devices: devices,
        company_id: this.company_id,
        sub_company_id: this.sub_company_id,
        spare_status: this.spareStatus ? 1 : 0,
        sub_company_selection: this.subCompanyStatus ? 1 : 0
      };

      try {
        const response = await Services.assignDevices(body);

        if (
          response.status === 200 ||
          response.status === 201 ||
          response.status === 204
        ) {
          this.multiCloseDialog();
          await this.getData();
          this.$infoBar({
            type: "success",
            text: "Device/s has been assigned to Company!"
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!"
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection"
          });
        }
      }
      this.confirmLoading = false;
    },
    async saveRemoveDialog() {
      this.messageLoading = true;

      try {
        const response = await Services.deleteDevice(this.viewData.id);

        if (response.status === 200 || response.status === 201) {
          this.closeMessageDialog();

          await this.getData();

          this.$infoBar({
            type: "success",
            text: "Device has been removed!"
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!"
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection"
          });
        }
      }
      this.messageLoading = false;
    },
    async closeDialog() {
      this.viewData = {};
      this.subcompanies = [];
      if (this.dialogLoading === false) {
        this.$refs.detailsRef.clear();
      }

      this.closeConfirmDialog();
      this.dialogType = "";
      this.dialogStatus = false;
    },
    multiCloseDialog() {
      this.dialogType = "";
      this.selected = [];
      this.assignCompany = "";
      this.company_id = null;
      this.multiAssignDialog = false;
      this.closeConfirmDialog();
    },
    closeConfirmDialog() {
      this.openConfirmDialog = false;
    },
    async closeMessageDialog() {
      this.messageDialog = false;
      this.viewData = {};
    },
    async closeDeleteDialog() {
      this.deleteDialog = false;
    },
    async openFilterExpansion() {
      this.openFilter = await !this.openFilter;
      await this.setFilterCompanies();
    },
    async refreshTable() {
      this.$refs.searchRef.clear();
      this.filterCompany = await null;
      await this.getData();
    }
  }
};
</script>

<style scoped>
.scrolling-wrapper {
  overflow-x: hidden;
  height: 400px;
  overflow-y: scroll;
  white-space: nowrap;
}
</style>
